export enum NavigationTypes {
    Upper = 'upper',
    Left = 'left'
}
